export default "__VITE_ASSET__DUWBbvx3__"